// eslint-disable-next-line no-restricted-imports
import { PortableText, type PortableTextBlock, type PortableTextComponents } from 'next-sanity'

import { createPortableTextLists } from '@/app/components/portableText/lists'
import { createPortableTextMarks } from '@/app/components/portableText/marks'
import { TrackingLocation } from '@/app/utils/analytics'

export default function PortableTextMinimal({
  value,
  tracking,
}: {
  value: PortableTextBlock[]
  tracking: TrackingLocation
}) {
  const components: PortableTextComponents = {
    block: {
      normal: ({ children }) => <>{children}</>,
    },
    marks: createPortableTextMarks(tracking),
    ...createPortableTextLists(),
  }

  return <PortableText components={components} value={value} />
}
